import { useSelector } from 'react-redux';

import { lineViewsSelector } from 'Redux/reselects/order-calc/line-view';

/**
 * The prices that a cart line shows (see line-view.js).
 * @param   {Object} item A cart item, or undefined.
 * @returns {Object}      The line view, or undefined when the item is not in the cart.
 */
export default function useLineView(item) {
  return useSelector(state => (item ? lineViewsSelector(state)[String(item._id)] : undefined));
}
